import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { ParcelsPreviewComponent } from '../../../components/parcels/parcels-preview/parcels-preview.component';

@Component({
  selector: 'app-irspa-detailed-information-on-the-letter-content-preview',
  standalone: true,
  imports: [
    ParcelsPreviewComponent
  ],
  templateUrl: './irspa-detailed-information-on-the-letter-content-preview.component.html'
})
export class IrspaDetailedInformationOnTheLetterContentPreviewComponent {

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public detailedInformation: Signal<boolean> = computed(() =>
    [
      '/wniosek-o-zmiane-aktu-planowania-przestrzennego',
      '/wniosek-do-projektu-aktu-planowania-przestrzennego',
      '/uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego'
    ].includes(this.application()?.service?.url || '')
  );

  public planName: Signal<boolean> = computed(() => {
    const app = this.application();
    switch (app?.service?.url) {
      case '/wniosek-o-sporządzenie-aktu-planowania-przestrzennego': {
        return false;
      }
      default: {
        return true;
      }
    }
  });
}
